import { IconLargeSun } from './IconLargeSun'

export default IconLargeSun
